/* List of feature flags available. These should be kept to a maximum of 2 since each added feature affects the form build complexity and duration.
 * store in the form:
 * const features = {
 *   FEATURE_ONE: 'feature_one',
 *   FEATURE_TWO: 'feature_two',
 * }
 */
const FEATURES = {};

export default FEATURES;
